module.exports = __webpack_public_path__ + "img/new-oilcard-empty-icon.57fd434d.png";